import { parseISO } from 'date-fns';
import { LOGGED_OUT } from 'actions/types';
import * as types from '../actions/types';
const initialState = {
    recentInteractions: [],
    creditAndDebt: undefined,
};
// move away from deprecated createFetchReducer
// move and fix necessary payments related reducers into here
const paymentsV2 = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_RECENT_INTERACTIONS_SUCCESS: {
            return {
                ...state,
                recentInteractions: action.payload.suggestedContacts.map((c) => 'beneficiaryId' in c ? { ...c, id: c.beneficiaryId } : c),
            };
        }
        case types.GET_CREDIT_AND_DEBT_SUCCESS: {
            const groupCredit = action.payload.creditBreakdown
                ?.filter((c) => !!c.spendingGroup)
                .sort((a, b) => b.amount - a.amount);
            const requestsCredit = action.payload.creditBreakdown
                ?.filter((c) => Boolean(c.paymentRequest))
                .sort((a, b) => parseISO(b.paymentRequest.createdAt) <
                parseISO(a.paymentRequest.createdAt)
                ? -1
                : 1);
            const groupDebt = action.payload.debtBreakdown
                ?.filter((d) => !!d.spendingGroup)
                .sort((a, b) => b.amount - a.amount);
            const requestsDebt = action.payload.debtBreakdown
                ?.filter((d) => Boolean(d.paymentRequest))
                .sort((a, b) => parseISO(b.paymentRequest.createdAt) <
                parseISO(a.paymentRequest.createdAt)
                ? -1
                : 1);
            const creditAndDebt = {
                ...action.payload,
                creditBreakdown: requestsCredit?.concat(groupCredit || []),
                debtBreakdown: requestsDebt?.concat(groupDebt || []),
            };
            return { ...state, creditAndDebt };
        }
        case LOGGED_OUT: {
            return initialState;
        }
        default:
            return state;
    }
};
export default paymentsV2;
